import React, { useState, useEffect } from "react";
import Banner from "./components/Banner";
import Campusvideo from "./components/Campusvideo";
import HomepageCarousel from "./components/HomepageCarousel";
import Newssection from "./components/Newssection";
import Recruiter from "./components/Recruiter";
import Courssection from "./components/Courssection";

export default function Homepage() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [currentDialogIndex, setCurrentDialogIndex] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isSmallScreen = windowWidth < 700;

  const dialogs = [
    {
      title: "Admissions 2025",
      content: (
        <>
          <div style={{ marginBottom: "30px" }}>
            <h3
              style={{
                fontSize: isSmallScreen ? "18px" : "24px", // Smaller font for small screens
              }}
            >
              Second Round Merit List Announced
            </h3>
          </div>
          <a
            target="_blank"
            href="https://jssuninoida.edu.in/assets/docs/Merit_List_02_26.05.2025.pdf"
            rel="noopener noreferrer"
            style={{
              display: "inline-block",
              padding: "10px 20px",
              backgroundColor: "#0066cc",
              color: "white",
              textDecoration: "none",
              borderRadius: "5px",
              fontSize: isSmallScreen ? "14px" : "16px", // Smaller font for small screens
            }}
          >
            View
          </a>
          <div style={{ marginTop: "30px" }}>
            <h3
              style={{
                fontSize: isSmallScreen ? "18px" : "24px",
              }}
            >
              Checklist for Counselling 2025-26
            </h3>
            <a
              href="https://jssuninoida.edu.in/assets/docs/checklist_2025-26.pdf"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-block",
                padding: "10px 20px",
                backgroundColor: "#0066cc",
                color: "white",
                textDecoration: "none",
                borderRadius: "5px",
                margin: "10px 0",
                fontSize: isSmallScreen ? "14px" : "16px",
              }}
            >
              View
            </a>
          </div>
        </>
      ),
    },
    {
      title: "Admissions",
      content: (
        <>
          <div
            style={{
              position: "relative",
              width: "100%",
              height: "400px",
              backgroundImage: `url(images/admissions.jpeg)`,
              backgroundSize: "contain",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
              alignItems: "center",
              padding: "20px",
            }}
          ></div>
          <a
            href="/admission-main"
            rel="noopener noreferrer"
            style={{
              display: "inline-block",
              padding: "10px 20px",
              backgroundColor: "#0066cc",
              color: "white",
              textDecoration: "none",
              borderRadius: "5px",
              marginTop: "20px",
              fontSize: isSmallScreen ? "14px" : "16px", // Smaller font for small screens
            }}
          >
            Apply Now
          </a>
        </>
      ),
    },
    {
      title: "Ph.D Programs",
      content: (
        <>
          <div
            style={{
              position: "relative",
              width: "100%",
              height: "500px",
              backgroundImage: `url(images/phd2.png)`,
              backgroundSize: "conver",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
              alignItems: "center",
              padding: "20px",
            }}
          ></div>
        </>
      ),
    },
    {
      title: "Important Announcements",
      content: (
        <>
          <div style={{ marginBottom: "30px" }}>
            <h3
              style={{
                fontSize: isSmallScreen ? "18px" : "24px", // Smaller font for small screens
              }}
            >
              INSPIRE- CONFERENCE SERIES Regulatory Pathways for Drug Approvals:
              Emerging Trends and Innovations
            </h3>
            <a
              href="https://jssuninoida.edu.in/assets/docs/Invitation_Inspire_Conference_Series_May%202_2025.pdf"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-block",
                padding: "10px 20px",
                backgroundColor: "#0066cc",
                color: "white",
                textDecoration: "none",
                borderRadius: "5px",
                margin: "10px 0",
                fontSize: isSmallScreen ? "14px" : "16px", // Smaller font for small screens
              }}
            >
              View
            </a>
          </div>
          <div style={{ marginBottom: "30px" }}>
            <h3
              style={{
                fontSize: isSmallScreen ? "18px" : "24px",
              }}
            >
              One Day Conclave on Science & Humanities for Sustainable Ecosystem
              Development
            </h3>
            <a
              href="https://jssuninoida.edu.in/assets/docs/Conclave_with_Surrey_%20Science_and_Humanities.pdf"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-block",
                padding: "10px 20px",
                backgroundColor: "#0066cc",
                color: "white",
                textDecoration: "none",
                borderRadius: "5px",
                margin: "10px 0",
                fontSize: isSmallScreen ? "14px" : "16px",
              }}
            >
              View
            </a>
          </div>
          <div>
            <h3
              style={{
                fontSize: isSmallScreen ? "18px" : "24px",
              }}
            >
              One Day Conclave on Semiconductors & Beyond: Building Powerful
              Computing Power
            </h3>
            <a
              href="https://jssuninoida.edu.in/assets/docs/Invitation_flyer_ECE_conclave.pdf"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-block",
                padding: "10px 20px",
                backgroundColor: "#0066cc",
                color: "white",
                textDecoration: "none",
                borderRadius: "5px",
                margin: "10px 0",
                fontSize: isSmallScreen ? "14px" : "16px",
              }}
            >
              View
            </a>
          </div>
          <div>
            <h3
              style={{
                fontSize: isSmallScreen ? "18px" : "24px",
              }}
            >
              One Day Conclave on Sustainable Development of Libraries Through
              Technology Integration in Alignment with NEP 2020
            </h3>
            <a
              href="https://jssuninoida.edu.in/assets/docs/Library_conclave_brouchure.pdf"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-block",
                padding: "10px 20px",
                backgroundColor: "#0066cc",
                color: "white",
                textDecoration: "none",
                borderRadius: "5px",
                margin: "10px 0",
                fontSize: isSmallScreen ? "14px" : "16px",
              }}
            >
              View
            </a>
          </div>
        </>
      ),
    },
  ];

  const handleCloseDialog = () => {
    if (currentDialogIndex < dialogs.length - 1) {
      setCurrentDialogIndex(currentDialogIndex + 1);
    } else {
      setCurrentDialogIndex(null);
    }
  };

  return (
    <>
      <HomepageCarousel />
      <Courssection />
      {/* <Banner /> */}
      <Campusvideo />
      {/* <Recruiter /> */}
      {currentDialogIndex !== null && (
        <div
          className="modal"
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10000,
            overflowY: "auto",
          }}
        >
          <div
            className="modal-content"
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              maxWidth: "800px",
              margin: "10px",
              maxHeight: "90vh",
              overflowY: "auto",
            }}
          >
            <div
              className="modal-header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "15px",
              }}
            >
              <h3
                className="modal-title"
                style={{
                  margin: 0,
                  fontSize: isSmallScreen ? "20px" : "28px", // Smaller font for modal title
                }}
              >
                {dialogs[currentDialogIndex].title}
              </h3>
              <button
                onClick={handleCloseDialog}
                className="close"
                style={{
                  background: "none",
                  border: "none",
                  fontSize: isSmallScreen ? "20px" : "24px", // Smaller font for close button
                  cursor: "pointer",
                  padding: "0 10px",
                }}
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <center>{dialogs[currentDialogIndex].content}</center>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
